var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2474 16.9014C11.8315 16.9014 12.3056 17.3665 12.3056 17.94C12.3059 18.5138 11.8313 18.9786 11.2469 18.9786C10.6621 18.9783 10.1875 18.514 10.1875 17.94C10.1877 17.366 10.6621 16.9014 11.2474 16.9014Z",
    fill: "url(#paint0_linear_486_1517)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3953 2.91686C19.9802 2.91686 20.4545 3.38235 20.4545 3.95589C20.4549 4.52965 19.9802 4.99447 19.3951 4.99447C18.8108 4.99424 18.3359 4.52988 18.3359 3.95589C18.3359 3.38213 18.8103 2.91709 19.3953 2.91686Z",
    fill: "url(#paint1_linear_486_1517)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6182 4.9147C32.2033 4.9147 32.6774 5.37996 32.6774 5.9535C32.6774 6.52749 32.2028 6.9923 31.618 6.9923C31.0332 6.99184 30.5586 6.52749 30.5586 5.9535C30.5588 5.37996 31.0329 4.91493 31.6182 4.9147Z",
    fill: "url(#paint2_linear_486_1517)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6304 17.9396C35.2155 17.9396 35.6891 18.4051 35.6891 18.9786C35.6894 19.5524 35.2155 20.0176 34.6304 20.0176C34.0449 20.0176 33.5703 19.5526 33.5703 18.9786C33.5705 18.4048 34.0447 17.94 34.6304 17.9396Z",
    fill: "url(#paint3_linear_486_1517)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8181 38.8762C45.4032 38.8762 45.8766 39.3415 45.8766 39.9152C45.877 40.489 45.4029 40.954 44.8181 40.954C44.2324 40.9536 43.7578 40.489 43.7578 39.9152C43.758 39.3415 44.2324 38.8764 44.8181 38.8762Z",
    fill: "url(#paint4_linear_486_1517)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5206 43.9107C29.1056 43.9107 29.5798 44.3758 29.5798 44.9495C29.58 45.5233 29.1054 45.9883 28.5203 45.9883C27.9358 45.9881 27.4609 45.5233 27.4609 44.9495C27.4614 44.3758 27.9355 43.9107 28.5206 43.9107Z",
    fill: "url(#paint5_linear_486_1517)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14925 29.9263C8.7343 29.9263 9.20772 30.3915 9.20772 30.9653C9.20772 31.5391 8.7343 32.0041 8.14925 32.0041C7.56443 32.0039 7.08984 31.5391 7.08984 30.9653C7.08984 30.3915 7.5642 29.9265 8.14925 29.9263Z",
    fill: "url(#paint6_linear_486_1517)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7298 43.9106C37.1594 43.9106 36.6693 43.4311 36.6693 42.8718C36.6697 42.3123 37.1591 41.8328 37.7296 41.8328C38.2995 41.8328 38.7881 42.3123 38.7881 42.8718C38.7076 43.4306 38.2177 43.9106 37.7298 43.9106ZM37.7298 39.9149C36.0184 39.9149 34.6328 41.2735 34.6328 42.9516C34.6328 44.6298 36.0181 45.9882 37.7296 45.9882C39.4401 45.988 40.8255 44.6298 40.8255 42.9516C40.8257 41.2731 39.3585 39.9151 37.7298 39.9149Z",
    fill: "url(#paint7_linear_486_1517)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.52635 35.9193C2.28208 35.9193 2.03738 35.6801 2.03738 35.4402C2.03738 35.2001 2.28185 34.9609 2.52635 34.9609C2.77176 34.9606 3.01536 35.2005 3.01536 35.4402C3.09701 35.6798 2.85226 35.9197 2.52635 35.9193ZM5.13417 35.4402C5.13417 34.0813 3.99312 32.963 2.60872 32.963C1.2234 32.963 0 34.0818 0 35.4402C0 36.7986 1.14103 37.9173 2.52635 37.9173C3.91189 37.9173 5.13394 36.7986 5.13417 35.4402Z",
    fill: "url(#paint8_linear_486_1517)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9881 33.6022C40.8253 34.0017 40.4175 34.3213 40.0101 34.5612L29.743 39.1156C26.8911 40.3945 23.5503 40.3945 20.6973 39.116C18.4166 38.1569 15.8086 39.116 14.8306 41.3535L14.5059 42.1525L8.31228 39.3557L8.96344 37.8373C11.3265 32.7231 17.4384 30.4058 22.6531 32.6433L23.4689 32.9629C26.8911 34.4808 30.8024 34.4013 34.1428 32.9629L38.3803 31.125C40.0102 30.4058 41.7214 32.0041 40.9881 33.6022ZM12.8751 45.6686L6.68225 42.9516L7.4974 41.1137L13.6907 43.9107L12.8751 45.6686ZM19.3944 25.9308C20.9428 25.9308 22.3279 26.5702 23.3058 27.689C23.7136 28.1683 24.5274 28.1683 24.935 27.689C26.2398 25.9308 28.3584 24.9719 30.6393 24.9719C33.6549 24.9719 36.2616 26.8099 37.3216 29.447L33.4102 31.125C30.5581 32.4035 27.2175 32.4037 24.3645 31.125L23.5508 30.8054C20.5352 29.4465 17.1939 29.447 14.2602 30.4858C14.5059 27.9286 16.7049 25.931 19.3944 25.9308ZM21.1875 19.8577C20.0464 19.8577 19.0682 19.1387 18.6609 18.1796L20.2095 18.1792C21.3503 18.1792 22.3279 18.8991 22.7354 19.8577H21.1875ZM21.1875 13.4649C20.0464 13.4649 19.0682 12.7458 18.6609 11.7867L20.2095 11.7865C21.3503 11.7865 22.3279 12.5063 22.7354 13.4649H21.1875ZM27.7884 11.7865H29.3354C28.9283 12.7458 27.9501 13.4649 26.8099 13.4649H25.2618C25.6694 12.5061 26.6462 11.7867 27.7884 11.7865ZM27.7884 18.1792H29.3354C28.9283 19.1385 27.9501 19.8577 26.8099 19.8577H25.2618C25.6694 18.8988 26.6462 18.1796 27.7884 18.1792ZM39.1955 28.9674C37.8916 25.3715 34.4696 22.9741 30.5579 22.9741C28.5207 22.9738 26.5648 23.6135 25.0173 24.7323L25.0175 21.9353H26.8102C29.4173 21.9353 31.5356 19.8577 31.5356 17.3008C31.5359 16.7413 31.0469 16.2617 30.4762 16.2617H27.7056C26.7281 16.2617 25.7499 16.5814 25.0173 17.1408L25.0175 15.5425H26.8102C29.4173 15.5425 31.5356 13.4649 31.5356 10.908C31.5359 10.3481 31.0469 9.86901 30.4762 9.86901H27.7056C26.7281 9.86901 25.7499 10.1886 25.0173 10.7481L25.0175 9.06987C25.0175 8.5106 24.5274 8.0313 23.957 8.0313C23.3868 8.03107 22.8985 8.51083 22.8985 9.06987V10.7477C22.165 10.1882 21.187 9.86901 20.2093 9.86901H17.4387C16.8683 9.86901 16.379 10.3485 16.379 10.908C16.3793 13.4649 18.4978 15.5428 21.1056 15.5428L22.8985 15.5425V17.1408C22.165 16.5814 21.187 16.2617 20.2093 16.2617H17.4387C16.8683 16.2617 16.379 16.7413 16.379 17.3008C16.3793 19.8577 18.4978 21.9355 21.1056 21.9355L22.8985 21.9353V24.9719C21.8382 24.3327 20.6166 24.0131 19.2313 24.0131C15.0763 24.0126 11.8164 27.4491 12.1423 31.5246C9.9412 32.803 8.14921 34.641 7.00839 37.1184L4.40061 43.1111C4.15611 43.5908 4.40058 44.2303 4.88957 44.39L12.9572 47.906C13.4455 48.1456 14.0981 47.9062 14.3419 47.4266L16.7052 42.1525C17.2758 40.9535 18.6609 40.3945 19.8831 40.954C23.3061 42.4721 27.2175 42.3923 30.5579 40.954L40.7436 36.399C43.1884 35.2802 43.9216 32.0841 41.8845 30.0862C41.2338 29.2871 40.2547 28.8875 39.1955 28.9674Z",
    fill: "url(#paint9_linear_486_1517)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7454 6.75223L44.5754 10.9079C42.1309 10.9079 39.1162 10.9081 36.9151 10.9081L40.7454 6.75223ZM41.805 17.9396H39.7676V12.9057H41.805V17.9396ZM34.6342 12.9855H37.7312V18.9784C37.7312 19.5381 38.219 20.0177 38.7894 20.0177H42.8644C43.4348 20.0177 43.9233 19.5381 43.9233 18.9786L43.9236 12.9855H47.0203C47.427 12.9855 47.7536 12.7458 47.9165 12.4264C48.0795 12.1066 47.9972 11.6273 47.7536 11.3874L41.6417 4.67486C41.2355 4.1951 40.5009 4.19555 40.0942 4.67508L33.9814 11.387C33.7378 11.707 33.6562 12.1068 33.8192 12.4264C33.9007 12.7458 34.2268 12.9855 34.6342 12.9855Z",
    fill: "url(#paint10_linear_486_1517)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20916 2.43745L13.0394 6.59219C10.5956 6.59219 7.58027 6.59265 5.37982 6.59265L9.20916 2.43745ZM3.0984 8.67024H6.19497V23.9331C6.19497 24.4923 6.6837 24.9719 7.25411 24.9719C7.82406 24.9719 8.15069 24.4926 8.15069 23.9331V8.67024H10.1881V14.6632C10.1881 15.2229 10.6768 15.7026 11.2472 15.7026C11.8179 15.7024 12.306 15.2231 12.306 14.6636L12.3062 8.67024H15.4027C15.8103 8.67024 16.136 8.43082 16.2991 8.11121C16.4621 7.71141 16.3805 7.31206 16.136 7.07218L10.025 0.359624C9.61741 -0.120135 8.88418 -0.119688 8.47661 0.359845L2.36558 7.07173C2.12017 7.39134 2.03877 7.79137 2.20253 8.11121C2.2835 8.4306 2.69061 8.67024 3.0984 8.67024Z",
    fill: "url(#paint11_linear_486_1517)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8194 24.9719C44.249 24.9719 43.7591 24.4926 43.7591 23.9331C43.7594 23.3736 44.2488 22.8946 44.8194 22.8946C45.3901 22.8943 45.8779 23.3739 45.8779 23.9331C45.8784 24.4924 45.3899 24.9719 44.8194 24.9719ZM44.8194 20.976C43.108 20.976 41.7227 22.3351 41.7227 24.0131C41.7229 25.6911 43.108 27.0498 44.8194 27.0498C46.5309 27.0495 47.916 25.6911 47.916 24.0131C47.9162 22.3349 46.5307 20.9764 44.8194 20.976Z",
    fill: "url(#paint12_linear_486_1517)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_486_1517",
    x1: 11.2466,
    y1: 16.9014,
    x2: 11.2466,
    y2: 18.9786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_1517",
    x1: 19.3952,
    y1: 2.91686,
    x2: 19.3952,
    y2: 4.99447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_1517",
    x1: 31.618,
    y1: 4.9147,
    x2: 31.618,
    y2: 6.9923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_486_1517",
    x1: 34.6297,
    y1: 17.9396,
    x2: 34.6297,
    y2: 20.0176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_486_1517",
    x1: 44.8172,
    y1: 38.8762,
    x2: 44.8172,
    y2: 40.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_486_1517",
    x1: 28.5203,
    y1: 43.9107,
    x2: 28.5203,
    y2: 45.9883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_486_1517",
    x1: 8.14878,
    y1: 29.9263,
    x2: 8.14878,
    y2: 32.0041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_486_1517",
    x1: 37.7291,
    y1: 39.9149,
    x2: 37.7291,
    y2: 45.9882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_486_1517",
    x1: 2.56709,
    y1: 32.963,
    x2: 2.56709,
    y2: 37.9173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_486_1517",
    x1: 23.6859,
    y1: 8.0313,
    x2: 23.6859,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_486_1517",
    x1: 40.8677,
    y1: 4.31524,
    x2: 40.8677,
    y2: 20.0177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_486_1517",
    x1: 9.25053,
    y1: 0,
    x2: 9.25053,
    y2: 24.9719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_486_1517",
    x1: 44.8193,
    y1: 20.976,
    x2: 44.8193,
    y2: 27.0498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon11.a8d76460f744dfd8356f5a8018f2d268.svg";
export { ForwardRef as ReactComponent };